import { crudFor } from "./dataClient";
import { seedForms, seedSubmissions } from "@/data/seed/forms";
import { normalizeForm } from "@/lib/normalizeForm";

export const formsCrud = crudFor("forms", seedForms);
export const submissionsCrud = crudFor("form_submissions", seedSubmissions);

export const formsService = {
  async listActiveForms() {
    const rows = await formsCrud.list((q) => q.eq("is_active", true));
    return rows.filter((f) => f.is_active !== false).map(normalizeForm);
  },

  async getForm(slug) {
    const row = await formsCrud.getBy("slug", slug);
    return row ? normalizeForm(row) : null;
  },

  async submit(formSlug, data) {
    return submissionsCrud.create({
      form_slug: formSlug,
      data,
      status: "new",
    });
  },

  async listSubmissions(formSlug) {
    const rows = await submissionsCrud.list((q) => {
      let query = q.order("created_at", { ascending: false });
      if (formSlug && formSlug !== "All") query = query.eq("form_slug", formSlug);
      return query;
    });
    return rows
      .filter((s) => !formSlug || formSlug === "All" || s.form_slug === formSlug)
      .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
  },

  setSubmissionStatus(id, status) {
    return submissionsCrud.update(id, { status });
  },
};
